import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as l}from"../../icon-registry.js";const t=i`
<svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    static
    xmlns="http://www.w3.org/2000/svg">
    <rect
        x="3.58057"
        y="18.9365"
        width="16.8482"
        height="1.15584"
        fill="#336699" />
    <rect
        x="2.34619"
        y="20.8115"
        width="19.0399"
        height="1.15584"
        fill="#336699" />
    <g clip-path="url(#clip0_4874_1085)">
        <path
            d="M6.30446 18.7485H4.91396C4.55486 18.7485 4.26416 18.5285 4.26416 18.2566C4.26416 18.016 4.49201 17.8159 4.79344 17.7732C4.78096 17.7136 4.77446 17.6526 4.77446 17.5903V10.5606C4.77446 10.4983 4.78096 10.4373 4.79344 10.3777C4.492 10.335 4.26416 10.1349 4.26416 9.89425C4.26416 9.62241 4.55486 9.40234 4.91396 9.40234H7.69406C8.05316 9.40234 8.34386 9.62241 8.34386 9.89425C8.34386 10.1347 8.11645 10.3346 7.81544 10.3776C7.82794 10.4372 7.83446 10.4983 7.83446 10.5606V17.5903C7.83446 17.6526 7.82794 17.7137 7.81544 17.7733C8.11645 17.8163 8.34386 18.0162 8.34386 18.2566C8.34386 18.5285 8.05316 18.7485 7.69406 18.7485H6.30446Z"
            fill="#336699" />
    </g>
    <g clip-path="url(#clip1_4874_1085)">
        <path
            d="M12.0584 18.7485H10.6679C10.3088 18.7485 10.0181 18.5285 10.0181 18.2566C10.0181 18.016 10.2459 17.8159 10.5473 17.7732C10.5349 17.7136 10.5284 17.6526 10.5284 17.5903V10.5606C10.5284 10.4983 10.5349 10.4373 10.5473 10.3777C10.2459 10.335 10.0181 10.1349 10.0181 9.89425C10.0181 9.62241 10.3088 9.40234 10.6679 9.40234H13.448C13.8071 9.40234 14.0978 9.62241 14.0978 9.89425C14.0978 10.1347 13.8704 10.3346 13.5693 10.3776C13.5818 10.4372 13.5884 10.4983 13.5884 10.5606V17.5903C13.5884 17.6526 13.5818 17.7137 13.5693 17.7733C13.8704 17.8163 14.0978 18.0162 14.0978 18.2566C14.0978 18.5285 13.8071 18.7485 13.448 18.7485H12.0584Z"
            fill="#336699" />
    </g>
    <g clip-path="url(#clip2_4874_1085)">
        <path
            d="M17.8084 18.7485H16.4179C16.0588 18.7485 15.7681 18.5285 15.7681 18.2566C15.7681 18.016 15.9959 17.8159 16.2973 17.7732C16.2849 17.7136 16.2784 17.6526 16.2784 17.5903V10.5606C16.2784 10.4983 16.2849 10.4373 16.2973 10.3777C15.9959 10.335 15.7681 10.1349 15.7681 9.89425C15.7681 9.62241 16.0588 9.40234 16.4179 9.40234H19.198C19.5571 9.40234 19.8478 9.62241 19.8478 9.89425C19.8478 10.1347 19.6204 10.3346 19.3193 10.3776C19.3318 10.4372 19.3384 10.4983 19.3384 10.5606V17.5903C19.3384 17.6526 19.3318 17.7137 19.3193 17.7733C19.6204 17.8163 19.8478 18.0162 19.8478 18.2566C19.8478 18.5285 19.5571 18.7485 19.198 18.7485H17.8084Z"
            fill="#336699" />
    </g>
    <path
        d="M3.07681 8.67927V6.70952H3.03369L3.07681 6.6867V6.26049H3.88198L11.8678 2.0332L19.8535 6.26049H20.7038V8.67927H3.07681Z"
        fill="#336699" />
    <ellipse
        cx="3.44098"
        cy="19.5144"
        rx="0.54791"
        ry="0.577919"
        fill="#336699" />
    <ellipse
        cx="20.1519"
        cy="19.5144"
        rx="0.54791"
        ry="0.577919"
        fill="#336699" />
    <ellipse
        cx="21.2535"
        cy="21.3894"
        rx="0.54791"
        ry="0.577919"
        fill="#336699" />
    <ellipse
        cx="2.34723"
        cy="21.3894"
        rx="0.54791"
        ry="0.577919"
        fill="#336699" />
    <mask
        id="mask0_4874_1085"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="14"
        y="14"
        width="9"
        height="8">
        <circle
            cx="18.5003"
            cy="17.7332"
            r="3.7"
            fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4874_1085)">
        <g clip-path="url(#clip3_4874_1085)">
            <path
                d="M12.9399 14.0322H24.0399V21.4322H12.9399V14.0322Z"
                fill="white" />
            <path
                d="M12.9399 14.0322H24.0399V14.6013H12.9399V14.0322ZM12.9399 15.1704H24.0399V15.7394H12.9399V15.1704ZM12.9399 16.3085H24.0399V16.8775H12.9399V16.3085ZM12.9399 17.4466H24.0399V18.0157H12.9399V17.4466ZM12.9399 18.5869H24.0399V19.156H12.9399V18.5869ZM12.9399 19.725H24.0399V20.2941H12.9399V19.725ZM12.9399 20.8632H24.0399V21.4322H12.9399V20.8632Z"
                fill="#D80027" />
            <path
                d="M12.9399 14.0322H18.4899V18.0157H12.9399V14.0322Z"
                fill="#2E52B2" />
            <path
                d="M13.9742 17.0374L13.8877 16.7604L13.7925 17.0374H13.5068L13.7384 17.204L13.6518 17.481L13.8877 17.31L14.117 17.481L14.0283 17.204L14.2641 17.0374H13.9742ZM15.1924 17.0374L15.1037 16.7604L15.0128 17.0374H14.7272L14.9587 17.204L14.8722 17.481L15.1037 17.31L15.3374 17.481L15.2508 17.204L15.4823 17.0374H15.1924ZM16.4149 17.0374L16.3219 16.7604L16.2353 17.0374H15.9432L16.1812 17.204L16.0903 17.481L16.3219 17.31L16.5599 17.481L16.469 17.204L16.7005 17.0374H16.4149ZM17.6309 17.0374L17.5444 16.7604L17.4535 17.0374H17.1657L17.3994 17.204L17.3129 17.481L17.5444 17.31L17.7781 17.481L17.685 17.204L17.923 17.0374H17.6309ZM15.1037 15.6613L15.0128 15.9382H14.7272L14.9587 16.1092L14.8722 16.3818L15.1037 16.213L15.3374 16.3818L15.2508 16.1092L15.4823 15.9382H15.1924L15.1037 15.6613ZM13.8877 15.6613L13.7925 15.9382H13.5068L13.7384 16.1092L13.6518 16.3818L13.8877 16.213L14.117 16.3818L14.0283 16.1092L14.2641 15.9382H13.9742L13.8877 15.6613ZM16.3219 15.6613L16.2353 15.9382H15.9432L16.1812 16.1092L16.0903 16.3818L16.3219 16.213L16.5599 16.3818L16.469 16.1092L16.7005 15.9382H16.4149L16.3219 15.6613ZM17.5444 15.6613L17.4535 15.9382H17.1657L17.3994 16.1092L17.3129 16.3818L17.5444 16.213L17.7781 16.3818L17.685 16.1092L17.923 15.9382H17.6309L17.5444 15.6613ZM13.8877 14.5664L13.7925 14.839H13.5068L13.7384 15.01L13.6518 15.2848L13.8877 15.1138L14.117 15.2848L14.0283 15.01L14.2641 14.839H13.9742L13.8877 14.5664ZM15.1037 14.5664L15.0128 14.839H14.7272L14.9587 15.01L14.8722 15.2848L15.1037 15.1138L15.3374 15.2848L15.2508 15.01L15.4823 14.839H15.1924L15.1037 14.5664ZM16.3219 14.5664L16.2353 14.839H15.9432L16.1812 15.01L16.0903 15.2848L16.3219 15.1138L16.5599 15.2848L16.469 15.01L16.7005 14.839H16.4149L16.3219 14.5664ZM17.5444 14.5664L17.4535 14.839H17.1657L17.3994 15.01L17.3129 15.2848L17.5444 15.1138L17.7781 15.2848L17.685 15.01L17.923 14.839H17.6309L17.5444 14.5664Z"
                fill="white" />
        </g>
    </g>
    <defs>
        <clipPath id="clip0_4874_1085">
            <rect
                width="3.69839"
                height="8.81326"
                fill="white"
                transform="translate(4.26416 9.40234)" />
        </clipPath>
        <clipPath id="clip1_4874_1085">
            <rect
                width="3.69839"
                height="8.81326"
                fill="white"
                transform="translate(10.0181 9.40234)" />
        </clipPath>
        <clipPath id="clip2_4874_1085">
            <rect
                width="3.69839"
                height="8.81326"
                fill="white"
                transform="translate(15.7681 9.40234)" />
        </clipPath>
        <clipPath id="clip3_4874_1085">
            <rect
                width="11.1"
                height="7.4"
                fill="white"
                transform="translate(12.9399 14.0322)" />
        </clipPath>
    </defs>
</svg>
`,r=l("bank_transfer_us",t),H=l("usbt",t),L=i`
<svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    static
    xmlns="http://www.w3.org/2000/svg">
    <mask
        id="mask0_4874_1081"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect
            width="24"
            height="24"
            fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4874_1081)">
        <rect
            x="3.78125"
            y="18.8359"
            width="16.8476"
            height="1.15104"
            fill="#336699" />
        <rect
            x="2.54688"
            y="20.7031"
            width="19.0392"
            height="1.15104"
            fill="#336699" />
        <g clip-path="url(#clip0_4874_1081)">
            <path
                d="M6.50514 18.6821H5.11464C4.75554 18.6821 4.46484 18.4621 4.46484 18.1902C4.46484 17.9496 4.69269 17.7495 4.99412 17.7068C4.98164 17.6472 4.97514 17.5862 4.97514 17.5239V10.4942C4.97514 10.4319 4.98164 10.3709 4.99412 10.3113C4.69268 10.2686 4.46484 10.0685 4.46484 9.82784C4.46484 9.556 4.75554 9.33594 5.11464 9.33594H7.89474C8.25384 9.33594 8.54454 9.556 8.54454 9.82784C8.54454 10.0683 8.31713 10.2682 8.01612 10.3112C8.02862 10.3708 8.03514 10.4319 8.03514 10.4942V17.5239C8.03514 17.5862 8.02862 17.6473 8.01612 17.7069C8.31713 17.7499 8.54454 17.9498 8.54454 18.1902C8.54454 18.4621 8.25384 18.6821 7.89474 18.6821H6.50514Z"
                fill="#336699" />
        </g>
        <g clip-path="url(#clip1_4874_1081)">
            <path
                d="M12.2591 18.6821H10.8686C10.5095 18.6821 10.2188 18.4621 10.2188 18.1902C10.2188 17.9496 10.4466 17.7495 10.748 17.7068C10.7356 17.6472 10.7291 17.5862 10.7291 17.5239V10.4942C10.7291 10.4319 10.7356 10.3709 10.748 10.3113C10.4466 10.2686 10.2188 10.0685 10.2188 9.82784C10.2188 9.556 10.5095 9.33594 10.8686 9.33594H13.6487C14.0078 9.33594 14.2985 9.556 14.2985 9.82784C14.2985 10.0683 14.071 10.2682 13.77 10.3112C13.7825 10.3708 13.7891 10.4319 13.7891 10.4942V17.5239C13.7891 17.5862 13.7825 17.6473 13.77 17.7069C14.071 17.7499 14.2985 17.9498 14.2985 18.1902C14.2985 18.4621 14.0078 18.6821 13.6487 18.6821H12.2591Z"
                fill="#336699" />
        </g>
        <g clip-path="url(#clip2_4874_1081)">
            <path
                d="M18.013 18.6821H16.6225C16.2634 18.6821 15.9727 18.4621 15.9727 18.1902C15.9727 17.9496 16.2005 17.7495 16.5019 17.7068C16.4895 17.6472 16.483 17.5862 16.483 17.5239V10.4942C16.483 10.4319 16.4895 10.3709 16.5019 10.3113C16.2005 10.2686 15.9727 10.0685 15.9727 9.82784C15.9727 9.556 16.2634 9.33594 16.6225 9.33594H19.4026C19.7617 9.33594 20.0524 9.556 20.0524 9.82784C20.0524 10.0683 19.8249 10.2682 19.5239 10.3112C19.5364 10.3708 19.543 10.4319 19.543 10.4942V17.5239C19.543 17.5862 19.5364 17.6473 19.5239 17.7069C19.8249 17.7499 20.0524 17.9498 20.0524 18.1902C20.0524 18.4621 19.7617 18.6821 19.4026 18.6821H18.013Z"
                fill="#336699" />
        </g>
        <path
            d="M3.27749 8.61845V6.65689H3.23438L3.27749 6.63416V6.20972H4.08264L12.0681 2L20.0535 6.20972H20.9038V8.61845H3.27749Z"
            fill="#336699" />
        <ellipse
            cx="3.64164"
            cy="19.4115"
            rx="0.54789"
            ry="0.575518"
            fill="#336699" />
        <ellipse
            cx="20.3526"
            cy="19.4115"
            rx="0.54789"
            ry="0.575518"
            fill="#336699" />
        <ellipse
            cx="21.4463"
            cy="21.2786"
            rx="0.54789"
            ry="0.575518"
            fill="#336699" />
        <ellipse
            cx="2.54789"
            cy="21.2786"
            rx="0.54789"
            ry="0.575518"
            fill="#336699" />
        <mask
            id="mask1_4874_1081"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="15"
            y="14"
            width="8"
            height="8">
            <circle
                cx="18.7"
                cy="17.7"
                r="3.7"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask1_4874_1081)">
            <g clip-path="url(#clip3_4874_1081)">
                <path
                    d="M13.1606 13.998H24.2606V21.3981H13.1606V13.998Z"
                    fill="white" />
                <path
                    d="M19.4044 13.998H18.0169V17.0043H13.1606V18.3918H18.0169V21.398H19.4044V18.3918H24.2606V17.0043H19.4044V13.998Z"
                    fill="#D80027" />
                <path
                    d="M21.6976 18.9854L24.2605 20.4092V18.9854H21.6976ZM19.917 18.9854L24.2605 21.3984V20.716L21.1453 18.9854H19.917ZM23.1035 21.3984L19.917 19.6279V21.3984H23.1035Z"
                    fill="#0052B4" />
                <path
                    d="M19.917 18.9854L24.2605 21.3984V20.716L21.1453 18.9854H19.917Z"
                    fill="white" />
                <path
                    d="M19.917 18.9854L24.2605 21.3984V20.716L21.1453 18.9854H19.917Z"
                    fill="#D80027" />
                <path
                    d="M15.1192 18.9854L13.1606 20.0735V18.9854H15.1192ZM17.5041 19.2922V21.3984H13.7133L17.5041 19.2922Z"
                    fill="#0052B4" />
                <path
                    d="M16.2759 18.9854L13.1606 20.716V21.3984L17.5041 18.9854H16.2759Z"
                    fill="#D80027" />
                <path
                    d="M15.7235 16.4111L13.1606 14.9872V16.4111H15.7235ZM17.5041 16.4111L13.1606 13.998V14.6804L16.2759 16.4111H17.5041ZM14.3176 13.998L17.5041 15.7685V13.998H14.3176Z"
                    fill="#0052B4" />
                <path
                    d="M17.5041 16.4111L13.1606 13.998V14.6804L16.2759 16.4111H17.5041Z"
                    fill="white" />
                <path
                    d="M17.5041 16.4111L13.1606 13.998V14.6804L16.2759 16.4111H17.5041Z"
                    fill="#D80027" />
                <path
                    d="M22.3019 16.4111L24.2605 15.323V16.4111H22.3019ZM19.917 16.1043V13.998H23.7078L19.917 16.1043Z"
                    fill="#0052B4" />
                <path
                    d="M21.1453 16.4111L24.2605 14.6804V13.998L19.917 16.4111H21.1453Z"
                    fill="#D80027" />
            </g>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_4874_1081">
            <rect
                width="3.69825"
                height="8.77665"
                fill="white"
                transform="translate(4.46484 9.33594)" />
        </clipPath>
        <clipPath id="clip1_4874_1081">
            <rect
                width="3.69825"
                height="8.77665"
                fill="white"
                transform="translate(10.2188 9.33594)" />
        </clipPath>
        <clipPath id="clip2_4874_1081">
            <rect
                width="3.69825"
                height="8.77665"
                fill="white"
                transform="translate(15.9727 9.33594)" />
        </clipPath>
        <clipPath id="clip3_4874_1081">
            <rect
                width="11.1"
                height="7.39999"
                fill="white"
                transform="translate(13.1606 13.998)" />
        </clipPath>
    </defs>
</svg>
`,c=l("bank_transfer_uk",L),s=l("ukbt",L);export{c as BankTransferUK,r as BankTransferUS,s as UKBT,H as USBT};
